import { router, useLocalSearchParams } from 'expo-router';
import { useEffect, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';

import FormWrapper from '@/components/forms/FormWrapper';
import ProgramForm from '@/components/forms/ProgramForm';
import { ProgramData } from '@/lib/validations/NpoOnboardingSchema';
import { safeJsonParse } from '@/utils/jsonParse';

const AddUpdateProgram = () => {
  const { programDataJson, programIndex } = useLocalSearchParams<{
    programDataJson: string;
    programIndex: string;
  }>();
  const [initialProgramData, setInitialProgramData] = useState<ProgramData | undefined>(undefined);

  useEffect(() => {
    if (programDataJson) {
      const parsedProgram = safeJsonParse<ProgramData>(programDataJson);
      if (parsedProgram) setInitialProgramData(parsedProgram);
    }
  }, [programDataJson]);

  return (
    <SafeAreaView style={styles.content} edges={['bottom']}>
      <FormWrapper scrollEnable={false}>
        <View style={styles.container}>
          <ProgramForm
            initialData={initialProgramData}
            showDoneButton
            onDone={(data) => {
              router.dismissTo({
                pathname: '/edit/npoPrograms',
                params: {
                  programDataJson: JSON.stringify(data),
                  programIndex: programIndex
                }
              });
            }}
          />
        </View>
      </FormWrapper>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  content: {
    flex: 1
  },
  container: {
    flex: 1
  }
});

export default AddUpdateProgram;
